/*
  MOVASANA — Tastaturzugriff auf waagerecht scrollbare Bereiche

  Wer nicht mit der Maus arbeitet, kommt an den Inhalt eines scrollenden
  Containers nur heran, wenn dieser selbst den Fokus annehmen kann (WCAG 2.1.1;
  axe-Regel "scrollable-region-focusable"). Betroffen sind die Ankuendigungs-
  leiste, die Produktgalerie, die Videoreihe und das Ritual-Raster.

  Warum das im Skript und nicht als festes tabindex="0" im Markup steht:
  ob ein Bereich ueberlaeuft, haengt an der Fensterbreite. Ein fester Tabstopp
  waere auf dem Desktop ein Stopp ohne Ziel — der Fokus landet auf einem
  Container, in dem es nichts zu scrollen gibt.

  Kein role: Galerie und Videoreihe sind <ul>. Eine Rolle darauf wuerde die
  Listensemantik verdraengen. aria-label allein benennt den Bereich beim Fokus,
  ohne etwas zu ueberschreiben.
*/
(() => {
  const bereiche = [
    ['.announcement-bar-slider .slider', 'Ankündigungen'],
    ['.product__media-list', 'Produktbilder'],
    ['.mv-videos__reihe', 'Videos'],
    ['.movasana-ritual__grid', 'Ablauf'],
  ];

  const pruefe = () => {
    for (const [selektor, beschriftung] of bereiche) {
      document.querySelectorAll(selektor).forEach((el) => {
        const laeuftUeber =
          el.scrollWidth > el.clientWidth + 2 || el.scrollHeight > el.clientHeight + 2;

        if (laeuftUeber) {
          el.setAttribute('tabindex', '0');
          el.setAttribute('aria-label', beschriftung);
        } else if (el.getAttribute('tabindex') === '0') {
          el.removeAttribute('tabindex');
          el.removeAttribute('aria-label');
        }
      });
    }
  };

  let wartet;
  const spaeter = () => {
    clearTimeout(wartet);
    wartet = setTimeout(pruefe, 150);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pruefe);
  } else {
    pruefe();
  }
  window.addEventListener('load', pruefe);
  window.addEventListener('resize', spaeter);
})();
